import {EnvironmentImageRequestParams} from "../../models/image/environment-image-request-params";

export class MobileHeaderSecondRequestParams extends EnvironmentImageRequestParams {
  constructor() {
    super({});

    this._resourceName = `/background/Mobile_header_second`;
  }
}
